class TrustedCertifiedVariantImage extends HTMLElement {
  constructor() {
    super();
    this.variantImages = {};
    this.boundHandleVariantChange = this.handleVariantChange.bind(this);
  }

  connectedCallback() {
    this.loadVariantData();
    this.setupEventListeners();
    this.detectInitialVariant();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  loadVariantData() {
    const dataScript = this.querySelector('script[type="application/json"]');
    if (dataScript) {
      try {
        this.variantImages = JSON.parse(dataScript.textContent);
      } catch (error) {
        console.error('Error parsing variant data:', error);
      }
    }
  }

  setupEventListeners() {
    // Listen for custom Shopify events
    document.addEventListener('variant:change', this.boundHandleVariantChange);

    // Detect Shopify variant selectors
    const variantSelectors = document.querySelectorAll('variant-selects, variant-radios, .variant-input');
    variantSelectors.forEach(selector => {
      selector.addEventListener('change', this.boundHandleVariantChange);
    });

    // Listen for product forms
    const productForms = document.querySelectorAll('form[action*="/cart/add"]');
    productForms.forEach(form => {
      const variantInputs = form.querySelectorAll('input[name="id"], select[name="id"]');
      variantInputs.forEach(input => {
        input.addEventListener('change', this.boundHandleVariantChange);
      });
    });

    // Setup listeners for custom dropdowns
    this.setupCustomDropdownListeners();
  }

  removeEventListeners() {
    document.removeEventListener('variant:change', this.boundHandleVariantChange);

    const variantSelectors = document.querySelectorAll('variant-selects, variant-radios, .variant-input');
    variantSelectors.forEach(selector => {
      selector.removeEventListener('change', this.boundHandleVariantChange);
    });

    const productForms = document.querySelectorAll('form[action*="/cart/add"]');
    productForms.forEach(form => {
      const variantInputs = form.querySelectorAll('input[name="id"], select[name="id"]');
      variantInputs.forEach(input => {
        input.removeEventListener('change', this.boundHandleVariantChange);
      });
    });
  }

  setupCustomDropdownListeners() {
    const customDropdowns = document.querySelectorAll('.custom-dropdown');
    customDropdowns.forEach(dropdown => {
      const items = dropdown.querySelectorAll('.custom-dropdown-content li');
      items.forEach(item => {
        item.addEventListener('click', () => {
          const variantId = item.dataset.varid;
          if (variantId) {
            setTimeout(() => {
              this.updateImage(variantId);
            }, 50);
          }
        });
      });
    });
  }

  handleVariantChange(event) {
    let variantId = null;

    // Different ways to get the variant ID
    if (event.detail?.variant?.id) {
      variantId = event.detail.variant.id;
    } else if (event.detail?.variantId) {
      variantId = event.detail.variantId;
    } else if (event.target.value) {
      variantId = event.target.value;
    } else if (event.currentTarget?.querySelector) {
      const checkedInput = event.currentTarget.querySelector('[name="id"]:checked');
      variantId = checkedInput?.value;
    }

    if (variantId) {
      this.updateImage(variantId);
    }
  }

  updateImage(variantId) {
    const imageData = this.variantImages[variantId];
    const sectionId = this.dataset.section;
    const productWrapper = document.querySelector(`.section-${sectionId} .trusted-certified__product-wrapper`);

    if (!productWrapper || !imageData || !imageData.variant_image) return;

    const productImage = productWrapper.querySelector('img');
    if (productImage) {
      productImage.src = imageData.variant_image;
      productImage.srcset = imageData.variant_image;
    }
  }

  detectInitialVariant() {
    // Search for input with current variant
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput && variantInput.value) {
      this.updateImage(variantInput.value);
    }

    // Also search in URL for variant parameter
    const urlParams = new URLSearchParams(window.location.search);
    const variantFromUrl = urlParams.get('variant');
    if (variantFromUrl) {
      this.updateImage(variantFromUrl);
    }
  }
}

// Register the custom element
customElements.define('trusted-certified-variant-image', TrustedCertifiedVariantImage);
